/* Lockett Labs Events: the hub (/pages/events).
   Filters, saved shows, countdowns, calendar files and live trader status.
   The filter rules and URL mirroring are the old hub's, unchanged, so links
   people have already shared (?game=pokemon&month=2026-11) still open the
   same view. */
(function () {
  'use strict';
  var EV = window.EV;
  var root = document.querySelector('[data-ev-hub]');
  if (!EV || !root) return;

  /* ---------------------------------------------------------------- bells, ics */
  EV.paintBells(root);
  document.addEventListener(EV.WATCH_EVT, function () { EV.paintBells(root); });
  window.addEventListener('storage', function (e) { if (!e || e.key === EV.WATCH_KEY) { EV.paintBells(root); if (state.saved) apply(); } });

  root.addEventListener('click', function (e) {
    var bell = e.target.closest('[data-ev-save]');
    if (bell) {
      e.preventDefault();
      var on = EV.toggleWatch(bell.getAttribute('data-ev-save'));
      EV.paintBells(root);
      EV.toast(on ? 'Saved to your list' : 'Removed from your list');
      if (state.saved) apply();
      return;
    }
    var cal = e.target.closest('[data-ev-ics]');
    if (cal) {
      e.preventDefault();
      EV.downloadIcs({ name: cal.getAttribute('data-name'), start: cal.getAttribute('data-start'), end: cal.getAttribute('data-end'), where: cal.getAttribute('data-where'), url: cal.getAttribute('data-url') });
    }
  });

  /* ---------------------------------------------------------------- filters */
  var grid = root.querySelector('[data-ev-grid]');
  var tools = root.querySelector('[data-ev-tools]');
  var cards = [];
  if (grid) {
    grid.querySelectorAll('[data-ev-card]').forEach(function (el) {
      cards.push({
        el: el, handle: el.getAttribute('data-handle') || '', status: el.getAttribute('data-status') || '',
        month: el.getAttribute('data-month') || '', town: el.getAttribute('data-town') || '',
        games: ' ' + (el.getAttribute('data-games') || '') + ' ', q: el.getAttribute('data-q') || '', on: true
      });
    });
  }
  var emptyEl = root.querySelector('[data-ev-empty]');
  var countEl = root.querySelector('[data-ev-count]');
  var clearEl = root.querySelector('[data-ev-clear]');
  var moreWrap = root.querySelector('[data-ev-more]');
  var PAGE = 9;
  var shown = PAGE;
  var state = { q: '', status: '', month: '', town: '', game: '', saved: '' };

  function readUrl() {
    try {
      var p = new URLSearchParams(location.search);
      Object.keys(state).forEach(function (k) { var v = p.get(k); if (v) state[k] = v; });
    } catch (e) { /* old browser */ }
  }
  function writeUrl() {
    try {
      var p = new URLSearchParams(location.search);
      Object.keys(state).forEach(function (k) { if (state[k]) p.set(k, state[k]); else p.delete(k); });
      var qs = p.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    } catch (e) { /* ignore */ }
  }
  function filtered() { return !!(state.q || state.status || state.month || state.town || state.game || state.saved); }

  function apply() {
    if (!cards.length) return;
    var watch = EV.readList(EV.WATCH_KEY);
    var q = state.q.trim().toLowerCase();
    var game = state.game ? ' ' + state.game + ' ' : '';
    var hits = 0;
    var f = filtered();
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var ok = true;
      if (q && c.q.indexOf(q) === -1) ok = false;
      if (ok && state.status && c.status !== state.status) ok = false;
      if (ok && state.month && c.month !== state.month) ok = false;
      if (ok && state.town && c.town !== state.town) ok = false;
      if (ok && game && c.games.indexOf(game) === -1) ok = false;
      if (ok && state.saved && watch.indexOf(c.handle) === -1) ok = false;
      if (ok) hits++;
      c.on = ok && (f || hits <= shown);
    }
    cards.forEach(function (c) { if (c.el.hidden === c.on) c.el.hidden = !c.on; });
    if (emptyEl) emptyEl.hidden = hits !== 0;
    if (countEl) {
      countEl.textContent = '';
      countEl.append(EV.el('b', { text: String(hits) }), ' ' + (hits === 1 ? 'show' : 'shows'));
    }
    if (clearEl) clearEl.hidden = !f;
    if (moreWrap) moreWrap.hidden = f || hits <= shown;
    root.querySelectorAll('[data-ev-f]').forEach(function (b) {
      b.setAttribute('aria-pressed', state[b.getAttribute('data-ev-f')] === (b.getAttribute('data-v') || '') ? 'true' : 'false');
    });
    writeUrl();
  }

  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-ev-f]');
    if (chip) {
      var k = chip.getAttribute('data-ev-f');
      var v = chip.getAttribute('data-v') || '';
      state[k] = state[k] === v && v !== '' ? '' : v;
      shown = PAGE;
      apply();
      // A game tile in the strip under the hero: take them to what it found.
      if (chip.hasAttribute('data-ev-floor') && state[k]) {
        var shows = document.getElementById('shows');
        if (shows) shows.scrollIntoView({ behavior: EV.reduce.matches ? 'auto' : 'smooth', block: 'start' });
      }
      return;
    }
    if (e.target.closest('[data-ev-clear]')) {
      Object.keys(state).forEach(function (kk) { state[kk] = ''; });
      var box = root.querySelector('[data-ev-q]');
      if (box) box.value = '';
      shown = PAGE;
      apply();
      return;
    }
    if (e.target.closest('[data-ev-more-btn]')) { shown += PAGE; apply(); }
  });
  var qBox = root.querySelector('[data-ev-q]');
  if (qBox) {
    var qt = null;
    qBox.addEventListener('input', function () { clearTimeout(qt); qt = setTimeout(function () { state.q = qBox.value; shown = PAGE; apply(); }, 140); });
  }
  if (tools) tools.hidden = false;
  readUrl();
  if (qBox && state.q) qBox.value = state.q;
  apply();

  /* ---------------------------------------------------------------- the shows' film */
  /* Our film behind Upcoming shows: the phone file on a phone, the full one
     elsewhere, fetched only when the section comes near and playing only
     while it is on screen. Reduced motion or data saver: the still frame. */
  (function () {
    var v = root.querySelector('[data-ev-shows-video]');
    if (!v) return;
    var saver = navigator.connection && navigator.connection.saveData;
    if (EV.reduce.matches || saver) return;
    var loaded = false;
    function load() {
      if (loaded) return;
      loaded = true;
      var small = Math.max(window.innerWidth, window.innerHeight) < 900 || window.innerWidth < 700;
      v.src = v.getAttribute(small ? 'data-src-sm' : 'data-src-lg');
      v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
    }
    function play() { load(); var p = v.play(); if (p && p.catch) p.catch(function () { /* autoplay refused: the still frame stays */ }); }
    if (!('IntersectionObserver' in window)) { play(); return; }
    new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) play(); else if (loaded) v.pause();
    }, { rootMargin: '200px 0px' }).observe(v.closest('section') || v);
    EV.reduce.addEventListener && EV.reduce.addEventListener('change', function () { if (EV.reduce.matches) { v.pause(); v.classList.remove('is-on'); } });
  })();

  /* ---------------------------------------------------------------- countdowns */
  function paintCountdowns() {
    root.querySelectorAll('[data-ev-countdown]').forEach(function (n) {
      var t = EV.countdownText(n.getAttribute('data-ev-countdown'));
      if (t && n.textContent !== t) n.textContent = t;
    });
  }

  EV.clock(root.querySelector('[data-ev-cd]'), root.querySelector('[data-ev-cd-label]'));
  var slow = setInterval(paintCountdowns, 60000);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { clearInterval(slow); slow = null; return; }
    paintCountdowns();
    if (!slow) slow = setInterval(paintCountdowns, 60000);
  });
  paintCountdowns();

  /* ---------------------------------------------------------------- the desk: dock, trader status, who's trading */
  var api = EV.apiBase(root.getAttribute('data-api'));
  var rowsBox = root.querySelector('[data-ev-trade-rows]');
  var nextHandle = root.getAttribute('data-next') || '';
  var dirUrl = root.getAttribute('data-dir-url') || '';
  var who = root.querySelector('[data-ev-who]');

  function paintTradeRows(list) {
    if (!rowsBox || !list.length) return;
    rowsBox.textContent = '';
    list.slice(0, 4).forEach(function (ev) {
      var a = ev.applications || {};
      var label = 'Closed';
      var cls = 'is-closed';
      var note = ev.dateLabel;
      if (a.state === 'open') { label = 'Open'; cls = 'is-open'; }
      else if (a.state === 'waitlist') { label = 'Reserve list'; cls = 'is-soon'; }
      else if (a.state === 'scheduled') { label = 'Opens ' + shortDate(a.opensAt); cls = 'is-soon'; }
      else if (a.state === 'full') { label = 'Full'; }
      if (a.accepting && a.remaining != null) note += ' · ' + a.remaining + (a.remaining === 1 ? ' place left' : ' places left');
      else if (a.accepting && a.closesAt) note += ' · closes ' + shortDate(a.closesAt);
      if (ev.tablesFrom && a.accepting) note += ' · tables from ' + ev.tablesFrom;
      rowsBox.append(EV.el('div', { class: 'ev-status-row' },
        EV.el('span', {}, EV.el('b', { text: ev.title }), EV.el('br'), note),
        EV.el('span', { class: 'ev-dotless ' + cls, text: label })));
    });
  }
  /* The dock's trade line: the soonest show taking applications, or when they open. */
  function paintDock(list) {
    var trade = root.querySelector('[data-dock-trade]');
    if (trade) {
      var open = list.filter(function (e) { return e.applications && e.applications.accepting; });
      var sched = list.filter(function (e) { return e.applications && e.applications.state === 'scheduled'; });
      var line = '';
      if (open.length) {
        var o = open[0].applications;
        line = 'Open for ' + (open.length === 1 ? open[0].title : open.length + ' shows')
          + (o.remaining != null ? ' · ' + o.remaining + ' left' : o.closesAt ? ' · closes ' + shortDate(o.closesAt) : '')
          + (open[0].tablesFrom ? ' · from ' + open[0].tablesFrom : '');
        trade.closest('.evx-dock__t').classList.add('is-hot');
      } else if (sched.length) line = 'Applications open ' + shortDate(sched[0].applications.opensAt);
      else line = 'Applications closed for now';
      trade.textContent = line;
    }
    // Each show card says how many traders are confirmed, linking to them.
    list.forEach(function (e) {
      var n = e.traders && e.traders.listed;
      var card = n ? root.querySelector('[data-ev-card][data-handle="' + (window.CSS && CSS.escape ? CSS.escape(e.handle) : e.handle) + '"]') : null;
      if (!card) return;
      var link = card.querySelector('.evx-card__who');
      if (!link) {
        link = EV.el('a', { class: 'evx-card__who', href: (dirUrl || '/pages/events') + (dirUrl.indexOf('?') > -1 ? '&' : '?') + 'show=' + encodeURIComponent(e.handle) }, EV.icon('users'), EV.el('span'));
        var slot = card.querySelector('[data-ev-who-slot]');
        var foot = card.querySelector('.ev-card__foot');
        if (slot) slot.append(link);
        else if (foot) foot.parentNode.insertBefore(link, foot);
      }
      link.querySelector('span').textContent = n + (n === 1 ? ' trader' : ' traders') + ' confirmed' + (e.traders.sponsors ? ' · ' + e.traders.sponsors + (e.traders.sponsors === 1 ? ' sponsor' : ' sponsors') : '');
    });
    var next = list.filter(function (e) { return e.handle === nextHandle; })[0];
    var whoLine = root.querySelector('[data-dock-who]');
    if (whoLine && next && next.traders && next.traders.listed > 0) {
      whoLine.textContent = next.traders.listed + (next.traders.listed === 1 ? ' trader' : ' traders') + ' confirmed'
        + (next.traders.sponsors ? ', ' + next.traders.sponsors + (next.traders.sponsors === 1 ? ' sponsor' : ' sponsors') : '');
    }
  }

  /* Who's trading: sponsors by level, then a strip of every trader. */
  function tierLabel(v) {
    return EV.el('span', { class: 'evx-tier is-' + v.tier }, EV.icon(v.tier === 'headline' ? 'crown' : 'star'), v.tierName);
  }
  function openVendor(v) {
    var link = (dirUrl || '/pages/events') + (dirUrl.indexOf('?') > -1 ? '&' : '?') + 'show=' + encodeURIComponent(nextHandle);
    EV.vendorDialog(v, { event: root.getAttribute('data-next-title') || '', url: EV.url(link), campaign: nextHandle });
  }
  function sponsorCard(v) {
    var b = EV.el('button', { type: 'button', class: 'evx-sponsor is-' + v.tier },
      EV.vendorLogo(v),
      EV.el('span', { class: 'evx-sponsor__tx' }, tierLabel(v), EV.el('b', { text: v.name }),
        v.blurb && v.tier !== 'partner' ? EV.el('span', { class: 'evx-sponsor__blurb', text: v.blurb }) : (v.categories[0] ? EV.el('span', { text: v.categories[0] }) : null)));
    b.addEventListener('click', function () { openVendor(v); });
    return b;
  }
  function chip(v) {
    var b = EV.el('button', { type: 'button', class: 'evx-mq' }, EV.vendorLogo(v),
      EV.el('span', { class: 'evx-mq__tx' }, EV.el('b', { text: v.name }), v.categories[0] ? EV.el('small', { text: v.categories[0] }) : null));
    b.addEventListener('click', function () { openVendor(v); });
    return b;
  }
  /* Every trader at the next show, for See every trader and the games strip:
     the page's own rows first (each once: the strip's copies are skipped),
     the desk's list once it answers. */
  var whoList = [];
  if (who) {
    var seenRow = {};
    who.querySelectorAll('[data-ev-vrow]:not([data-clone])').forEach(function (n) {
      var v = EV.vendorFrom(n.getAttribute('data-ev-vrow'));
      if (v.name && !seenRow[v.name]) { seenRow[v.name] = 1; whoList.push(v); }
    });
  }
  function paintWho(list) {
    if (!who) return;
    var vendors = EV.vendorSort(list);
    whoList = vendors;
    paintFloor();
    var spons = who.querySelector('[data-ev-who-spons]');
    var marq = who.querySelector('[data-ev-who-marq]');
    var track = who.querySelector('[data-ev-who-track]');
    var empty = who.querySelector('[data-ev-who-empty]');
    var count = who.querySelector('[data-ev-who-count]');
    var sp = vendors.filter(function (v) { return v.tier; });
    spons.textContent = '';
    sp.forEach(function (v) { spons.append(sponsorCard(v)); });
    track.textContent = '';
    track.removeAttribute('data-looped');
    marq.classList.remove('is-static');
    vendors.forEach(function (v) { track.append(chip(v)); });
    marq.hidden = !vendors.length;
    empty.hidden = !!vendors.length;
    if (vendors.length) who.removeAttribute('data-empty'); else who.setAttribute('data-empty', '');
    if (count) {
      count.textContent = vendors.length
        ? vendors.length + (vendors.length === 1 ? ' trader' : ' traders') + (sp.length ? ', ' + sp.length + (sp.length === 1 ? ' sponsor' : ' sponsors') : '') + ' so far'
        : 'Traders are announced as they are confirmed.';
    }
    var faces = root.querySelector('[data-dock-faces]');
    if (faces) {
      faces.textContent = '';
      vendors.slice(0, 4).forEach(function (v) { faces.append(EV.vendorLogo(v, '')); });
    }
    loop();
  }
  /* The games strip, lit by the next show's traders: a game someone is
     bringing shows how many, one nobody has marked yet goes dark. Until there
     is at least one trader to go on, the strip is left as it is. */
  var FLOOR_MATCH = { pokemon: /pok[eé]mon/i, onepiece: /one\s*piece/i, disney: /lorcana|disney/i, magic: /magic|mtg/i, digimon: /digimon/i, japanese: /japan/i };
  function paintFloor() {
    var tiles = root.querySelectorAll('[data-floor-key]');
    if (!tiles.length) return;
    var list = whoList;
    var any = list.length > 0;
    var lit = 0;
    tiles.forEach(function (li) {
      var re = FLOOR_MATCH[li.getAttribute('data-floor-key')];
      var n = re ? list.filter(function (v) { return v.categories.some(function (c) { return re.test(c); }); }).length : 0;
      if (n) lit++;
      li.classList.toggle('is-stocked', any && n > 0);
      li.classList.toggle('is-quiet', any && n === 0);
      var badge = li.querySelector('[data-floor-n]');
      if (badge) {
        badge.hidden = !any;
        badge.textContent = n ? n + (n === 1 ? ' trader' : ' traders') : 'None yet';
      }
      var card = li.querySelector('[data-label]');
      if (card) card.setAttribute('aria-label', card.getAttribute('data-label') + (any ? '. ' + (n ? n + (n === 1 ? ' trader is' : ' traders are') + ' bringing it to the next show' : 'Nobody has said they are bringing it yet') : ''));
    });
    var note = root.querySelector('[data-floor-note]');
    if (note) {
      var title = root.getAttribute('data-next-title') || 'the next show';
      note.hidden = !any;
      note.textContent = any ? (lit ? 'Lit up: what the traders at ' + title + ' are bringing.' : 'The traders at ' + title + ' have not said what they are bringing yet.') : '';
    }
  }
  paintFloor();

  /* A seamless strip: the list twice over, moving half its width, at a pace
     set by how long it is. Paused off screen and under the pointer, and
     never moving for reduced motion (it wraps into rows instead). */
  function loop() {
    var marq = who && who.querySelector('[data-ev-who-marq]');
    var track = marq && marq.querySelector('[data-ev-who-track]');
    if (!track || track.hasAttribute('data-looped')) return;
    var items = Array.prototype.slice.call(track.children);
    if (items.length < 5 || EV.reduce.matches) { marq.classList.add('is-static'); return; }
    items.forEach(function (n) { var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.tabIndex = -1; c.setAttribute('data-clone', String(items.indexOf(n))); track.append(c); });
    track.setAttribute('data-looped', '');
    track.style.setProperty('--evx-mq-dur', Math.max(30, items.length * 4.5) + 's');
    if ('IntersectionObserver' in window && !marq.__io) {
      marq.__io = new IntersectionObserver(function (en) { marq.classList.toggle('is-paused', !en[0].isIntersecting); });
      marq.__io.observe(marq);
    }
  }
  root.addEventListener('click', function (e) {
    var all = e.target.closest('[data-ev-who-all]');
    if (all && whoList.length && EV.allTraders) {
      e.preventDefault();
      EV.allTraders(whoList, { event: root.getAttribute('data-next-title') || '', url: EV.url(all.href), campaign: nextHandle, pageUrl: all.href });
      return;
    }
    // a clone in the strip opens the trader it copies
    var clone = e.target.closest('.evx-mq[data-clone]');
    if (clone) {
      var orig = clone.parentNode.children[Number(clone.getAttribute('data-clone'))];
      if (orig) orig.click();
      return;
    }
    // server-rendered traders work before the desk answers
    var row = e.target.closest('[data-ev-vrow]');
    if (row) openVendor(EV.vendorFrom(row.getAttribute('data-ev-vrow')));
  });
  if (who) loop();

  if (api) {
    EV.api(api, 'public.php?action=events').then(function (d) {
      var list = d.events || [];
      paintTradeRows(list);
      paintDock(list);
    }).catch(function () {
      if (rowsBox) rowsBox.querySelectorAll('[data-ev-trade-state]').forEach(function (n) { if (n.textContent === 'Checking') n.textContent = 'See the traders page'; });
    });
    if (who && nextHandle) {
      EV.api(api, 'public.php?action=vendors&handle=' + encodeURIComponent(nextHandle)).then(function (d) {
        var list = (d.vendors || []).map(EV.vendorFrom);
        // An empty answer from the desk never wipes a list the show page already has.
        if (list.length || !who.querySelector('[data-ev-vrow]')) paintWho(list);
      }).catch(function () { /* the server-rendered list stands */ });
    }
  }

  function shortDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  }
})();
